import React from "react";
import {
  createStyles,
  Theme,
  WithStyles,
  withStyles,
} from "@material-ui/core/styles";
import { ResponsiveLine } from "@nivo/line";
import { getMomentDate } from "../constants/constants";

interface Props extends WithStyles<typeof styles> {
  graphData: any;
  graph: any;
  xLabel: any;
  yLabel: any;
  maxAllowedLine: any;
  timeScale: any;
  colors?: any;
}
const styles = (theme: Theme) =>
  createStyles({
    root: {
      height: "100%",
      overflow: "auto",
      display: "flex",
    },
  });
class CurveLineGraphComponent extends React.Component<Props> {
  HorizontalTick = (tick: any) => {
    const MAX_LINE_LENGTH = 20;
    const MAX_LINES = 10;
    const LENGTH_OF_ELLIPSIS = 3;
    const TRIM_LENGTH = MAX_LINE_LENGTH * MAX_LINES - LENGTH_OF_ELLIPSIS;
    const trimWordsOverLength = new RegExp(`^(.{${TRIM_LENGTH}}[^\\w]*).*`);
    const groupWordsByLength = new RegExp(
      `([^\\s].{0,${MAX_LINE_LENGTH}}(?=[\\s\\W]|$))`,
      "gm"
    );
    const splitValues = tick.value
      .replace(trimWordsOverLength, "$1...")
      .match(groupWordsByLength)
      .slice(0, 2)
      .map((val: any, i: any) => (
        <tspan
          key={val}
          dy={20}
          x={0}
          style={{ fontFamily: "sans-serif", fontSize: "10px" }}
        >
          {val}
        </tspan>
      ));
    return (
      <g transform={`translate(${tick.x},${tick.y})`}>
        <text
          alignmentBaseline={tick.textBaseline}
          textAnchor={tick.textAnchor}
        >
          {splitValues}
        </text>
      </g>
    );
  };

  getNormalToolTip = (point: any) => {
    let { yLabel } = this.props;
    return (
      <div>
        <div>
          <strong>{point.data.x}</strong>
        </div>
        <div
          key={point.id}
          style={{
            padding: "3px 0",
          }}
        >
          {`${point.data.y} ${yLabel}`}
        </div>
      </div>
    );
  };

  getRotateToolTip = (point: any) => {
    let { yLabel } = this.props;
    return (
      <div>
        <div>
          <strong>{`Temp: ${point.data.x} ºC`}</strong>
        </div>
        <div
          key={point.id}
          style={{
            padding: "3px 0",
          }}
        >
          {`${point.data.y} ${yLabel}`}
        </div>
      </div>
    );
  };

  getToolTip = (point: any, index: any) => {
    let { yLabel } = this.props;
    return (
      <div key={index.toString()}>
        <div
          key={point.id}
          style={{
            padding: "3px 0",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "row",
          }}
        >
          <div
            style={{
              width: 12,
              height: 12,
              borderRadius: 10,
              backgroundColor: point.serieColor,
              marginRight: 4,
            }}
          />
          {`${point.data.y} ${yLabel}`}
        </div>
      </div>
    );
  };

  render() {
    const {
      classes,
      graphData,
      graph,
      xLabel,
      yLabel,
      maxAllowedLine,
      timeScale,
      colors,
    } = this.props;
    return (
      <div className={classes.root}>
        <ResponsiveLine
          margin={{
            top: 50,
            right: graph === "normal" ? 20 : 110,
            bottom: 100,
            left: 60,
          }}
          data={graphData}
          lineWidth={3}
          pointSize={10}
          pointColor={{ theme: "background" }}
          pointBorderWidth={3}
          isInteractive={true}
          pointBorderColor={{ from: "serie.color" }}
          axisRight={null}
          axisBottom={{
            format: "%b %d",
            tickValues: timeScale ? timeScale : "every month",
            orient: "bottom",
            tickSize: 5,
            tickPadding: 5,
            tickRotation: -35,
            legend: xLabel,
            legendOffset: 65,
            legendPosition: "middle",
          }}
          axisLeft={{
            orient: "left",
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: yLabel,
            legendOffset: -40,
            legendPosition: "middle",
            format: (e: any) => {
              if (Math.floor(e) !== e) {
                return;
              }
              return e;
            },
          }}
          xScale={{
            type: "time",
            format: "%d/%m/%Y",
            useUTC: false,
            precision: "day",
          }}
          xFormat="time:%d/%m/%Y"
          enableSlices={"x"}
          sliceTooltip={({ slice }) => {
            let toolTips = new Array<any>();
            slice.points.map((slicePoint: any, index: any) => {
              if (slicePoint.data) {
                toolTips.push(this.getToolTip(slicePoint, index));
              }
              return null;
            });
            return (
              <div
                style={{
                  background: "white",
                  padding: "9px 12px",
                  border: "1px solid #ccc",
                }}
              >
                {slice.points && slice.points.length > 0 && (
                  <div>
                    {xLabel.includes("Temperature") ? (
                      <strong>{`Temp: ${slice.points[0].data.x.toString()} ºC`}</strong>
                    ) : (
                      <strong>
                        {getMomentDate(
                          slice.points[0].data.x.toString(),
                          "DD/MM/YYYY"
                        )}
                      </strong>
                    )}
                  </div>
                )}
                {toolTips}
              </div>
            );
          }}
          colors={colors ? colors : ["blue", "red"]}
          //   pointSize={6}
          //   pointColor={{ from: "color", modifiers: [] }}
          //   pointBorderWidth={2}
          //   pointBorderColor={{ from: "serieColor" }}
          pointLabel="y"
          pointLabelYOffset={-12}
          useMesh={true}
          legends={[
            {
              anchor: "bottom-right",
              direction: "column",
              justify: false,
              translateX: 100,
              translateY: 0,
              itemsSpacing: 0,
              itemDirection: "left-to-right",
              itemWidth: 80,
              itemHeight: 20,
              itemOpacity: 0.75,
              symbolSize: 12,
              symbolShape: "circle",
              symbolBorderColor: "rgba(0, 0, 0, .5)",
              effects: [
                {
                  on: "hover",
                  style: {
                    itemBackground: "rgba(0, 0, 0, .03)",
                    itemOpacity: 1,
                  },
                },
              ],
            },
          ]}
          markers={[
            {
              axis: "y" as "y",
              value: maxAllowedLine ? 38 : 0,
              lineStyle: {
                stroke: maxAllowedLine ? "red" : "transparent",
                strokeWidth: 2,
                strokeDasharray: "2",
              },
            },
          ]}
          // xScale={{
          //   type: "time",
          //   format: "%d/%m/%Y",
          //   useUTC: false,
          //   precision: "day",
          // }}
          // xFormat="time:%d/%m/%Y"
          // yScale={{
          //   type: "linear",
          //   stacked: boolean("stacked", false),
          // }}
          // axisLeft={{
          //   legend: "linear scale",
          //   legendOffset: 12,
          // }}
          // axisBottom={{
          // format: "%b %d",
          // tickValues: "every month",
          // legend: "time scale",
          // legendOffset: -12,
          // }}
          // curve={"natural"}
          // enablePointLabel={true}
          // pointSymbol={CustomSymbol}
          // pointSize={16}
          // pointBorderWidth={1}
          // pointBorderColor={{
          //   from: "color",
          //   modifiers: [["darker", 0.3]],
          // }}
          // useMesh={true}
          // enableSlices={false}

          // xScale={{
          //   type: "point",
          // }}
          // yScale={{
          //   type: "linear",
          //   min: 0,
          //   max: "auto",
          //   stacked: false,
          //   reverse: false,
          // }}
          // enableSlices={"x"}
          // sliceTooltip={({ slice }) => {
          //   let toolTips = new Array<any>();
          //   slice.points.map((slicePoint: any, index: any) => {
          //     if (slicePoint.data) {
          //       toolTips.push(this.getToolTip(slicePoint, index));
          //     }
          //     return null;
          //   });
          //   return (
          //     <div
          //       style={{
          //         background: "white",
          //         padding: "9px 12px",
          //         border: "1px solid #ccc",
          //       }}
          //     >
          //       {slice.points && slice.points.length > 0 && (
          //         <div>
          //           {xLabel.includes("Temperature") ? (
          //             <strong>{`Temp: ${slice.points[0].data.x} ºC`}</strong>
          //           ) : (
          //             <strong>{slice.points[0].data.x}</strong>
          //           )}
          //         </div>
          //       )}
          //       {toolTips}
          //     </div>
          //   );
          // }}
          // curve={"linear"}
          // axisTop={null}
          // axisRight={null}
          // isInteractive={true}
          // axisBottom={{
          // orient: "bottom",
          // tickSize: 5,
          // tickPadding: 5,
          // tickRotation: -35,
          // legend: xLabel,
          // legendOffset: 65,
          // legendPosition: "middle",
          // }}
          // axisLeft={{
          // orient: "left",
          // tickSize: 5,
          // tickPadding: 5,
          // tickRotation: 0,
          // legend: yLabel,
          // legendOffset: -40,
          // legendPosition: "middle",

          // format: (e: any) => {
          //   if (Math.floor(e) !== e) {
          //     return;
          //   }
          //   return e;
          // },
          // }}
          //   markers={[
          //     {
          //       axis: "y" as "y",
          //       value: maxAllowedLine ? 38 : 0,
          //       lineStyle: {
          //         stroke: maxAllowedLine ? "red" : "transparent",
          //         strokeWidth: 2,
          //         strokeDasharray: "2",
          //       },
          //     },
          //     {
          //       axis: "x" as "x",
          //       value: 38,
          //       lineStyle: {
          //         stroke: maxAllowedLine ? "red" : "transparent",
          //         strokeWidth: 2,
          //         strokeDasharray: "2",
          //       },
          //     },
          //   ]}
          //   colors={colors ? colors : ["blue", "red"]}
          //   pointSize={6}
          //   pointColor={{ from: "color", modifiers: [] }}
          //   pointBorderWidth={2}
          //   pointBorderColor={{ from: "serieColor" }}
          //   pointLabel="y"
          //   pointLabelYOffset={-12}
          //   useMesh={true}
          //   legends={[
          //     {
          //       anchor: "bottom-right",
          //       direction: "column",
          //       justify: false,
          //       translateX: 100,
          //       translateY: 0,
          //       itemsSpacing: 0,
          //       itemDirection: "left-to-right",
          //       itemWidth: 80,
          //       itemHeight: 20,
          //       itemOpacity: 0.75,
          //       symbolSize: 12,
          //       symbolShape: "circle",
          //       symbolBorderColor: "rgba(0, 0, 0, .5)",
          //       effects: [
          //         {
          //           on: "hover",
          //           style: {
          //             itemBackground: "rgba(0, 0, 0, .03)",
          //             itemOpacity: 1,
          //           },
          //         },
          //       ],
          //     },
          //   ]}
        />
      </div>
    );
  }
}
export default withStyles(styles)(CurveLineGraphComponent);
